export default {
  props: ['project'],
  computed: {
    labelStyle: function () {
      if (this.$isEngCom) {
        return {
          'background-color': this.labelBackground
        }
      }
    },
    labelBackground: function () {
      if (this.$isEngCom) {
        switch (this.contentType) {
          case 'game':
            return '#037A96'
          case 'TV':
            return '#037A96'
          case 'project':
            return '#037A96'
          default:
            return '#502875'
        }
      }
    },
    contentType: function () {
      if (this.$isEngCom) {
        const isResource = this.project?.resource?.type?.name
        const isGame = this.project.categories?.length > 0 && this.project.categories?.every(cat => cat.slug === 'stem-games')
        const isTv = this.project.categories?.filter(function (category) {
          return category.parentID === 266
        }).length > 0
        if (isGame) {
          return 'game'
        } else if (isTv) {
          return 'TV'
        } else if (isResource) {
          return isResource
        } else {
          return this.project.type
        }
      } else if (this.project.isTemplate) {
        return 'Template'
      }
    }
  }
}
